import HTTP from '@/api/HTTP';

const URL_BASE = 'gescom/Facture/';

export async function PGetAllAnonymeAsync(hash, Query) {
  const response = await HTTP.post(URL_BASE + 'PGetAllAnonymeAsync', {
    query: Query.query,
    sorting: Query.sorting,
    skipCount: (Query.page - 1) * Query.limit,
    maxResultCount: Query.limit,
  }, { params: { hash } });
  return response;
}

export const NOTHING = '';
